document.addEventListener('DOMContentLoaded', () => {
  const modalLinks = document.querySelectorAll<HTMLElement>("[href^='#modal-section-']")

  modalLinks.forEach(l => {
    l.dataset.bsToggle = 'modal'
    l.dataset.bsTarget = l.getAttribute('href')
  })
})
